function NoPage() {
    return (
        <div className="flex justify-center">
            <h1>Error 404: Uh-Oh! Page Not Found :(</h1>
        </div>
    );
}
  
export default NoPage;